/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Action_Error1Inputs */

const vi_driverremittance_action_error1 = /** @type {(inputs: Driverremittance_Action_Error1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể thực hiện thao tác. Vui lòng thử lại.`)
};

/**

* @param {Driverremittance_Action_Error1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_action_error1 = /** @type {((inputs?: Driverremittance_Action_Error1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Action_Error1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_action_error1(inputs)
});
export { driverremittance_action_error1 as "driverRemittance_action_error" }